import Cookies from "js-cookie";
import { decryptData, secretKey } from "./Encrypt";

export const userData = () => {
  const authTokens = Cookies.get("authTokens");

  const decryptedJSON = decryptData(authTokens, secretKey);
  return decryptedJSON;
};
